import React from 'react';
import home_light from '../assets/images/home_light.svg';

const NavBar = ({url, label}) => {
  return (
    <>
    <div className="home-button">
      <a href={url}>
        <img 
          alt="Home Icon" 
          src={home_light} 
          width="30" 
          height="30" 
          className="d-inline-block align-top"
        />
      </a>
    </div>    
      <div className="separator"></div>
      <div className="label">
        {label}
      </div>
    </>
  );
};

export default NavBar;
